import { render, staticRenderFns } from "./edit-2.vue?vue&type=template&id=1dd501df&"
import script from "./edit-2.vue?vue&type=script&lang=js&"
export * from "./edit-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd501df')) {
      api.createRecord('1dd501df', component.options)
    } else {
      api.reload('1dd501df', component.options)
    }
    module.hot.accept("./edit-2.vue?vue&type=template&id=1dd501df&", function () {
      api.rerender('1dd501df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/edit-2.vue"
export default component.exports